<template>
    <div>
      <!--通知详情单-->
      <div class="Orderinfordiv" id="Noticeinformain_1">
        <web-notice :data_id="data.id" div_name="Noticeinformain_1"></web-notice>
      </div>
      <!--添加通知信息-->
      <div class="logindiv" id="AddForm_notice">
        <Notice @childFn="getData" url="AddNotice" div_name="AddForm_notice"></Notice>
      </div>
      <div>
        <el-container>
          <el-header style="background-color:white;margin-top: 5px;height: 40px;">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
              <el-form-item>
                <el-button type="primary" class="btn" @click="Addwindow()"><i class="el-icon-circle-plus-outline"></i>添加新通知</el-button>
              </el-form-item>
              <el-form-item label="标题">
                <el-input v-model="formInline.title" placeholder="标题" class="elInput"></el-input>
              </el-form-item>
              <el-form-item label="起始日期">
                <el-date-picker v-model="formInline.statetime" type="datetime" value-format="timestamp" placeholder="起始日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期">
                <el-date-picker v-model="formInline.endtime" type="datetime" value-format="timestamp" placeholder="结束日期"></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn" @click="getData()"><i class="el-icon-search"></i>查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" class="btn" @click="resetting()"><i class="el-icon-refresh"></i>重置</el-button>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main class="elMain">
            <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium ">
              <el-table-column align="center" label="ID" prop="id" width="150"></el-table-column>
              <el-table-column align="center" label="发布人" prop="admin_name" width="300"></el-table-column>
              <el-table-column align="center" label="标题" prop="title">
                <template slot-scope="scope">
                  <span>{{scope.row.title}}</span>
                  <span style="font-size: 5px;" v-if="PD_Notice_NEWOR(scope.row.time)">
                    <em><strong><mark>New</mark></strong></em>
                  </span>
                  <span v-if="scope.row.top_type=='1'"><el-tag size="mini" type="danger">置顶</el-tag></span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="浏览次数" prop="num" width="100"></el-table-column>
              <el-table-column align="center" label="发布时间" prop="time" width="250">
                <template slot-scope="scope">
                  <span>{{scope.row.time*1 | formatDate}}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="300">
                <template slot-scope="scope">
                  <span>
                    <el-button size="small" type="primary" @click="openInformation(scope.row)">详情</el-button>
                  </span>
                  <span v-if="scope.row.top_type=='1'">
                    <el-button size="small" type="info" @click="updateTopType(scope.row)">取消置顶</el-button>
                  </span>
                  <span v-else>
                    <el-button size="small" type="warning" @click="updateTopType(scope.row)">置顶</el-button>
                  </span>
                  <span>
                    <el-popconfirm
                      confirmButtonText='好的'
                      cancelButtonText='不用了'
                      icon="el-icon-info"
                      iconColor="red"
                      title="这是一段内容确定删除吗？"
                      @onConfirm="deletes(scope.$index, scope.row)"
                    >
                      <el-button size="small" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <div style="padding: 15px 0;text-align: right;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
              </el-pagination>
            </div>
          </el-footer>
        </el-container>
      </div>
    </div>
</template>

<script>
  import Notice from '@/admin/views/A_zujian/Notice.vue'//通知组件
  import web_notice from '@/admin/views/A_zujian/web_notice.vue'//前端通知详情组件
  import {commonAPI} from '@/api/commonAPI'
  export default {
    components: {
      'Notice': Notice,
      'web-notice': web_notice,
    },
    data() {
      return {
        content:'',
        data:'',
        tableData: [],
        loading: false,
        formInline: {
          statetime:'',
          title:'',
          endtime:'',
          type:'0',
          pageNum:1,
          pageSize:10
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0,
      }
    },

    filters: {
          formatDate: function (value) {
            /*返回总体日期*/
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            /*返回判断日期*/
            let timestamp = (new Date()).valueOf();
            let time=timestamp-value;//时间差
            let minute = 1000*60;
            let hour = minute * 60;
            var day = hour * 24;
            let times="";//内容
            let min = time/minute;//分钟
            let hours = time/hour;//天数
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
          }
        },

    created() {
      //this.getData();
    },
    //页面开启时执行
    mounted(){
      this.chark();
      this.getData();
    },
    methods: {
      //进行判定
      chark(){
        this.$emit("parentHandle", 2)
      },
      //判断是否为NEW
      PD_Notice_NEWOR(data){//data为传入时间参数
        let newdate=new Date().getTime();//获取当前时间
        let oneday=86400000;
        let time = newdate*1-data*1;
        if(time*1<=oneday*10){
          return true;
        }else{
          return false;
        }
      },
      //进行置顶修改
      updateTopType(row) {
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        //console.log(index, row);
        commonAPI('updateNoticeType',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //！！！！
      //打开通知详情
      openInformation(data){
        this.data="";
        this.data=data;
        sessionStorage.setItem("notice_infor_data",JSON.stringify(this.data));
        document.getElementById('Noticeinformain_1').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      closeInformation(){
        this.data='';
        let dobj=document.getElementById("aboutHtml_notice");
        dobj.innerHTML = '';
        document.getElementById('Noticeinformain_1').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
      //重置查询
      resetting() {
        this.formInline.title = '';
        this.formInline.statetime = '';
        this.formInline.endtime = '';
        this.getData();
      },
      Addwindow(row){
        //this.AddForm.message_id=row.id;
        document.getElementById('AddForm_notice').style.display='block';
        document.getElementById('zhedang').style.display='block';
        //console.log('打开窗口');
      },
      //删除
      deletes(index, row) {
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        //console.log(index, row);
        commonAPI('deleteNotice',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //查询
      getData() {
        this.loading = true,
          commonAPI('queryNoticeList',this.formInline).then(res => {
            this.loading = false;
            this.tableData = res.data.data.rows;
            this.pageTotal=res.data.data.total;
            //console.log(res.data.rows);
          })
      },
      onSubmit() {
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      },
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 20%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2006;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 700px;
    max-height: 600px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }

  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:23;
    overflow: auto;
    display: none;
  }
  .OrderinforForm{
    margin: 0 auto;
    width: 900px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .OrderinforForm a{
    color: #fff;
  }
  .OrderinforForm a:hover{
    color: #d6d6d6;
  }
  .playlistbox_botton{
     width: 900px;margin: 0 auto;
     overflow: hidden;
     height: 633px;
     overflow-y: scroll;
   }
   /**滚动条样式*/
   .playlistbox_botton::-webkit-scrollbar{
     width: 5px;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     border-radius: 10px;
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     background: #535353;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     border-radius: 10px;
     background: #EDEDED;
   }
   /**！Orderinfor框架*/
</style>



// WEBPACK FOOTER //
// src/admin/views/notice/Notice.vue